import * as TypeGraphQL from "type-graphql";
export var ConfigurationScalarFieldEnum;
(function (ConfigurationScalarFieldEnum) {
    ConfigurationScalarFieldEnum["id"] = "id";
    ConfigurationScalarFieldEnum["configKey"] = "configKey";
    ConfigurationScalarFieldEnum["configValue"] = "configValue";
    ConfigurationScalarFieldEnum["type"] = "type";
    ConfigurationScalarFieldEnum["scope"] = "scope";
    ConfigurationScalarFieldEnum["version"] = "version";
    ConfigurationScalarFieldEnum["description"] = "description";
    ConfigurationScalarFieldEnum["isActive"] = "isActive";
    ConfigurationScalarFieldEnum["expiresAt"] = "expiresAt";
    ConfigurationScalarFieldEnum["createdAt"] = "createdAt";
    ConfigurationScalarFieldEnum["updatedAt"] = "updatedAt";
})(ConfigurationScalarFieldEnum || (ConfigurationScalarFieldEnum = {}));
TypeGraphQL.registerEnumType(ConfigurationScalarFieldEnum, {
    name: "ConfigurationScalarFieldEnum",
    description: undefined,
});
//# sourceMappingURL=ConfigurationScalarFieldEnum.js.map